import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent } from "@mui/material";
import { Button, Form, FormControlLabel, Stack, Switch, Typography } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { isFunction, refIsRequiredError } from "@util/utils";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";

const SwitchField = forwardRef((props, ref) => {
    const { title, defaultChecked } = props;
    const [checked, setChecked] = useState(defaultChecked);
    const switchRef = useRef();

    const handleChange = (e, checked) => {
        setChecked(checked);
    };

    useEffect(() => {
        setChecked(defaultChecked);
    }, [defaultChecked]);

    useImperativeHandle(
        ref,
        () => ({
            getResult: () => checked,
            isError: refIsRequiredError(switchRef),
        }),
        [checked]
    );

    return (
        <Stack className={"notify-item"} justifyContent={"center"} alignItems={"center"}>
            <Typography className={"mb-0 mr-2 font-weight-bold"}>{title}</Typography>
            <FormControlLabel onChange={handleChange} control={<Switch defaultChecked={checked} inputProps={{ ref: switchRef }} />} label={checked ? "開啟" : "關閉"} />
        </Stack>
    );
});

const MarketingDialog = React.forwardRef((props, ref) => {
    const { className, open, sourceData, onClose, refresh } = props;
    if (!open) return null;
    const { memberID, hasMarketing } = sourceData || {};

    const { putMemberProfileNotifyMarketingActionApi } = useMemberProfileApi();

    const marketingRef = useRef();

    const doMemberProfileNotifyApi = async (memberID, params) => {
        let resp = await putMemberProfileNotifyMarketingActionApi(memberID, params);
        if (resp) {
            const { enabled } = resp;
            isFunction(refresh) && refresh(enabled);
            isFunction(onClose) && onClose();
        }
    };

    const handleSubmit = () => {
        if (!refIsRequiredError(marketingRef)) {
            let params = {
                enabled: marketingRef.current && isFunction(marketingRef.current.getResult) && marketingRef.current.getResult(),
            };

            doMemberProfileNotifyApi(memberID, params);
        }
    };

    return (
        <Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-40rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
            <GradientColorHeader onClose={onClose}>行銷設定</GradientColorHeader>
            <DialogContent>
                <SwitchField ref={marketingRef} title="可接受行銷訊息" key={hasMarketing} defaultChecked={hasMarketing} />
            </DialogContent>
            <DialogActions>
                <Button type={"submit"} variant="contained">
                    確認送出
                </Button>
            </DialogActions>
        </Dialog>
    );
});

export default MarketingDialog;
